import React, { useState } from "react"
import LotsRow from "./LotsRow"
import iconAdd from "./../../../../Assets/Img/iconAdd2Edit.svg"

export default function MainRow({
	isTag,
	item,
	selectedProducts = [],
	handleAddOrRemoveItems,
	}) {
	const [openInfo, setOpenInfo] = useState(false)

	const productId = item?.data?._id
	const productName = item?.data?.name || "-"
	const productQuantity = item?.data?.quantity || 0
	const quantityToSend = item?.quantityToSend || 0

	const selectedProduct = selectedProducts.find(
		selectedProduct => selectedProduct?.data?._id === productId
	)

	const measureName =
		item?.data?.measure?.name ||
		item?.data?.unitType?.name ||
		"-"

	const weightOrVolume = item?.data?.weightOrVolume

	const lots = item?.data?.lots || []

	return (
		<>
		<tr className={`${!isTag && openInfo === false ? "border-bottom-table" : ""}`}>
			<td className="text-start boldBigText">
			{productName}
			</td>

			{!isTag ? (
			<>
				<td className="quantity-td">
				<input
					type="number"
					min="1"
					value={
						selectedProducts.find(
						selectedProduct => selectedProduct?.data?._id === item?.data?._id
						)?.quantityRequested || ""
					}
					onChange={e => handleAddOrRemoveItems(item, e.target.value)}
					className="
						tw-w-[100px]
						tw-min-w-[100px]
						tw-h-[24px]
						tw-inline-block
						tw-rounded-md
						tw-border
						tw-border-gray-400
						tw-bg-white
						tw-px-2
						tw-py-1
						tw-text-sm
						tw-text-gray-900
						tw-outline-none
						focus:tw-border-[#42999b]
						focus:tw-ring-2
						focus:tw-ring-[#42999b]/20
					"
					/>
				</td>

				<td className={productQuantity - quantityToSend < 0 ? "text-red" : ""}>
				{`${productQuantity} ud/s.`}
				</td>
			</>
			) : (
			<>
				<td></td>
				<td></td>
			</>
			)}

			<td>
			{`${measureName}${weightOrVolume ? ` (${weightOrVolume} c/u)` : ""}`}
			</td>

			{!isTag && (
			<td>
				<button
				type="button"
				className="lotButton"
				onClick={() => setOpenInfo(prev => !prev)}
				>
				<img src={iconAdd} alt="Icono ver más" />
				</button>
			</td>
			)}
		</tr>

		{openInfo && <LotsRow lots={item?.data?.lots || []} />}
		</>
	)
}